<template>
  <div id="main">
    <div class="left">
      <span class="title">当前节次已点名班级的异常缺勤</span>
      <template v-if="data.length>0">
        <el-table size="mini" :data="data" border :show-header="false">
          <el-table-column prop="Grade" width="60" align="center" />
          <el-table-column>
            <template slot-scope="{row}">
              <span v-for="(item,index) in row.UnNormalClassStat" :key="index">
                {{item.Class}}
                <span>(</span>
                <span :style="item.HasTimetable?'color:#f22;':'color:#0c0;'">{{item.ClassTeacherName}}</span>
                <span>)</span>
                <span v-if="item.UnNormalStudents">{{'：' + item.UnNormalStudents}}</span>
                <span v-if="index+1<row.UnNormalClassStat.length">；</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="right">
      <span class="title">当前节次未点名班级</span>
      <template v-if="data.length>0">
        <el-table size="mini" :data="data" border :show-header="false">
          <el-table-column prop="Grade" width="60" align="center" />
          <el-table-column>
            <template slot-scope="{row}">
              <span v-for="(item,index) in row.UnRollcallClasses" :key="index">{{item}}<span v-if="index+1<row.UnRollcallClasses.length">，</span></span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div style="margin-top:15px;padding-left:4px;">备注：班主任姓名绿色表示该当前节次无课，红色则表示有课</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      data: [],
    };
  },
  mounted() {},
  methods: {
    setData(data) {
      // data.forEach(e => {
      //   e.UnRollcallClasses = ["班级1（任课教师1）","班级2（任课教师2）","班级3（任课教师3）"];
      //   e.UnNormalClassStat = [
      //     { Class: "班级1", ClassTeacherName: "班主任1", HasTimetable: true, UnNormalStudents: "张三，李四，王五" },
      //     { Class: "班级1", ClassTeacherName: "班主任1", HasTimetable: false, UnNormalStudents: "" },
      //   ];
      // });
      this.data = data;
      // console.log("??",this.data)
    },
  },
};
</script>
<style lang="scss" scoped>
 #main {
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
   .left,.right{
     width: 49.5%;
     @media screen and (max-width: 767px) {
       width: 100%;
     }
     .title{
       font-size: 14px;
       color: #606266;
       display: inline-block;
       margin: 10px 0 8px;
     }
   }
 }
</style>